module.exports = __webpack_public_path__ + "static/media/novice.d374a849.svg";